import React from 'react';
import Animation from '@dealroadshow/uikit-animation';
import styles from './intro.module.scss';

const Intro = () => (
  <div className={ styles.intro }>
    <div className={ styles.introContainer }>
      <h1 className={ styles.introTitle }>
        Your clients will appreciate another option. Instantly get a quote for DealVDR
      </h1>
      <div className={ styles.introDescription }>
        A great data room, at an industry leading price, with fanatical 24x7 support.{ ' ' }
        Backed by a 30-Day FREE trial and a 20% Savings Guarantee *
      </div>
    </div>
    <Animation />
  </div>
);

export default Intro;
